export default __webpack_public_path__ + "c78b1ef9e9a761421d7b8e10f5bc83cd.svg";